import createHashHistory from 'history/lib/createHashHistory';
import React from 'react';
import ReactDOM from 'react-dom';
import Relay from 'react-relay';
import { useRouterHistory } from 'react-router';
import { RelayRouter } from 'react-router-relay';
import "./loadingAnimation.css";
import "./toggle.css"
import injectTapEventPlugin from 'react-tap-event-plugin';
injectTapEventPlugin();
// import "./assets/bootstrap-fileinput/css/fileinput.min.css";

import routes from './routes';

Relay.injectNetworkLayer(
  new Relay.DefaultNetworkLayer('http://surveymate-io.herokuapp.com/graphql')
);

const history = useRouterHistory(createHashHistory)({ queryKey: false });

const mountNode = document.createElement('div');
document.body.appendChild(mountNode);

// var bootstrap = document.createElement('link');
// bootstrap.rel = 'stylesheet';
// bootstrap.href = 'https://maxcdn.bootstrapcdn.com/bootstrap/3.3.6/css/bootstrap.min.css';

// var scrollbar = document.createElement('link');
// scrollbar.rel = 'stylesheet';
// scrollbar.href = 'http://dndw32r4edmw5.cloudfront.net/scrollbar.css';

// var filecss = document.createElement('link');
// filecss.rel = 'stylesheet';
// filecss.href = 'http://dndw32r4edmw5.cloudfront.net/bootstrap-fileinput/css/fileinput.min.css';

// document.head.appendChild(bootstrap);
// document.head.appendChild(scrollbar);
// document.head.appendChild(filecss);

// var jquery = document.createElement('script');
// jquery.src = 'https://ajax.googleapis.com/ajax/libs/jquery/2.2.2/jquery.min.js';

// var bootstrapScript = document.createElement('script');
// bootstrapScript.src = 'https://maxcdn.bootstrapcdn.com/bootstrap/3.3.6/js/bootstrap.min.js';

// var fileScript = document.createElement('script');
// fileScript.src = 'http://dndw32r4edmw5.cloudfront.net/bootstrap-fileinput/js/fileinput.min.js';

// document.body.appendChild(jquery);
// document.body.appendChild(fileScript);
// document.body.appendChild(bootstrapScript);

document.body.setAttribute("id","style-1");

ReactDOM.render(
  <RelayRouter history={history} routes={routes} />,
  // document.getElementById('app')
  mountNode
);



/** WEBPACK FOOTER **
 ** ./src/client.js
 **/